@if (isTvEyes && !mention.expired) {
    <agpr-panel header="Mention.details.mentionView">
        <div class="agpr-mentionView-container">
            @if (mention.tvEyesPodcastID) {
                @if (tvEyesThumbnailSrc) {
                    <div class="agpr-mentionView-tvEyesThumbnailContainer">
                        <button
                            class="agpr-mentionView-tvEyesThumbnailButton"
                            (click)="openTvEyesPodcastPlayer()"
                        >
                            <img
                                class="agpr-mentionView-tvEyesThumbnail"
                                [class.agpr-mentionView-tvEyes--hasPlayer]="true"
                                [src]="tvEyesThumbnailSrc | agprBypassURLSecurity"
                                [alt]="'Mention.details.podcastPreviewImage' | localize"
                            />
                            <div
                                class='agpr-mentionView-tvEyesPlayButton'
                                [attr.aria-label]="'Core.button.play' | localize"
                            ></div>
                        </button>
                    </div>
                } @else {
                    <agpr-button
                        [id]="id + '_edit_tvEyes'"
                        [style]="buttonTypes.tertiary"
                        label="Mention.details.openMediaPlayer"
                        (click)="openTvEyesPodcastPlayer()"
                    ></agpr-button>
                }
            } @else {
                <div class="agpr-mentionView-tvEyesThumbnailContainer agpr-contextMenu-parent">
                    <button
                        class="agpr-mentionView-tvEyesThumbnailButton"
                        (click)="openTVEyesDialog()"
                    >
                        <img
                            class="agpr-mentionView-tvEyesThumbnail"
                            [src]="tvEyesThumbnailSrc | agprBypassURLSecurity"
                            [alt]="'Mention.details.podcastPreviewImage' | localize"
                            (error)="tvEyesThumbnailSrc = 'https://thumbnails.tveyes.com/images/playClip.gif'"
                        />
                        <div
                            class='agpr-mentionView-tvEyesPlayButton'
                            [attr.aria-label]="'Core.button.play' | localize"
                        ></div>
                    </button>
                    <div class="agpr-contextMenu top right agpr-mentionView-contextMenu">
                        @if (showTvEyesEditButton) {
                            <agpr-button
                                [id]="id + '_edit_tvEyes'"
                                [style]="buttonTypes.contextMenu"
                                icon="fa-duotone fa-regular fa-film"
                                [disabled]="!mention.mentionId"
                                [tooltip]="mention.mentionId ? 'Mention.details.openMediaEditor.tooltip' : 'Mention.details.openMediaEditor.unavailable'"
                                tooltipPosition="top"
                                (click)="openTVEyesDialog()"
                            ></agpr-button>
                        }

                        @if (hasPrecisionClipPermission && mention.isPrecisionClipable()) {
                            <agpr-button
                                [id]="id + '_precisionClip_tvEyes'"
                                [style]="buttonTypes.contextMenu"
                                icon="fa-kit-duotone fa-auto-clip"
                                tooltip="Mention.details.precisionClip.tooltip"
                                tooltipPosition="top"
                                (click)="openPrecisionClipDialog()"
                            ></agpr-button>
                        }

                        @if (mention.tvEyesArchiveState === tvEyesState.EDITED) {
                            <agpr-button
                                [id]="id + '_precisionClip_revert_tvEyes'"
                                class="agpr-mentionView-contextMenuLast"
                                [style]="buttonTypes.contextMenu"
                                icon="fa-duotone fa-regular fa-turn-left"
                                tooltip="Mention.details.precisionClip.revert.tooltip"
                                tooltipPosition="top"
                                (click)="openRevertDialog()"
                            ></agpr-button>
                        }

                        @if (showArchiveButton) {
                            <agpr-button
                                [id]="id + '_archive_tvEyes'"
                                [style]="buttonTypes.contextMenu"
                                icon="fa-duotone fa-regular fa-box-archive"
                                [disabled]="!mention.mentionId"
                                tooltip="Mention.details.archiveMention.tooltip"
                                tooltipPosition="top"
                                (click)="openArchiveDialog()"
                            ></agpr-button>
                        }
                    </div>
                </div>

                @if (!hasPrecisionClipPermission) {
                    <agpr-agentic-upsell-banner
                        heading="Monitor.precisionClip.upsell.header"
                        message="Monitor.precisionClip.upsell.message"
                    ></agpr-agentic-upsell-banner>
                }

                @switch (mention.tvEyesArchiveState) {
                    @case (tvEyesState.PROCESSING) {
                        <agpr-message [severity]="messageSeverityEnum.info">
                            {{ 'Mention.details.tvEyesProcessing' | localize }}
                        </agpr-message>
                    }
                    @case (tvEyesState.EDITED) {
                        <agpr-message [severity]="messageSeverityEnum.info">
                            {{ 'Mention.details.tvEyesEdited' | localize }}
                            <agpr-button
                                [id]="id + '_revertLink'"
                                class="agpr-mentionView-revertLink"
                                label="Mention.details.precisionClip.revertlink"
                                [style]="buttonTypes.link"
                                (click)="openRevertDialog()"
                            ></agpr-button>
                        </agpr-message>
                    }
                    @case (tvEyesState.COMPLETED) {
                        <agpr-message [severity]="messageSeverityEnum.info">
                            {{ 'Mention.details.tvEyesArchived' | localize }}
                        </agpr-message>
                    }
                }
            }
        </div>
    </agpr-panel>
}
